//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters, mapActions } from "vuex";
import sharedMethods from '../../sharedMethods';

export default {
	components: { },
	props: ["show", "device", "group"],
	computed: {
		...mapGetters([
			"allUserPlaylists",
			"getMediaFilesForPlaylist",
			"getGroupPlaylists",
			"getDeviceAssignedPlaylistByIDs"
		]),
	},
	data() {
		return { 
			playlistIds: [],
			groupId: null,
			deviceId: null,
			name: ''
		};
	},
	created() { 
		if(this.group) {
			// Following playlists have to be checked initially if more than one device is given
			this.groupId = this.group.GID;
			this.playlistIds = this.getGroupPlaylists(this.groupId).map((playlist) => { return playlist.ID });
			this.name = this.group.GNAME;
		} else if (this.device) {
			// Following playlists have to be checked initially if a device is given
			this.deviceId = this.device.DID;
			this.name = this.device.NAME;
			this.playlistIds = this.getDeviceAssignedPlaylistByIDs(this.deviceId);
		}
	},
	methods: {
		...mapActions([
			"updateDevicePlaylists",
			"updateGroupPlaylists"
		]),
		isChecked(playlistId) {
			return this.playlistIds.includes(playlistId);
		},
		checkPlaylist(playlistId) {
			if(this.playlistIds.includes(playlistId)) {
				this.playlistIds = this.playlistIds.filter(id => id !== playlistId);
			} else {
				this.playlistIds.push(playlistId);
			}
		},
		routePlaylists() {
			this.$router.push('playlist');
		},
		async save() {
			try {
				if(this.device) {
					await this.updateDevicePlaylists({deviceId: this.deviceId, playlistIds: this.playlistIds});
				} else if(this.group) {
					await this.updateGroupPlaylists({groupId: this.groupId, playlistIds: this.playlistIds});
				}
				sharedMethods.successNotify('Playlists assigned.');
				this.emitClose();
			} catch(err) {
				sharedMethods.errorNotify('An error occured saving playlists the playlists.')
				console.log(err);
				this.emitClose();
			}
		},
		emitClose() {
			this.$emit('popup-close');
		},
	},
};
